import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill.js';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill.js';

export default () => (
  <SectionContainer
    id='investment-advisory-services-faq' // '-section-container' will be appended dynamically
    className='nmx-no-print'
    moduleName='faq-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        align='center'
        medium={10}
        large={8}>
        <Typography
          component='h2'
          nextElement='typography'>
          Questions about investment advisory services&#63; <WidowBlock>We&#39;ve got answers.</WidowBlock>
        </Typography>
      </Col>
    </Row>
    <Row align='center'>
      <Col
        medium={10}
        large={8}>
        <Accordion
          id='faq-investment-advisory-services'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          items={[
            {
              id: 'investment-advisory-services-what-are-investment-advisory-services-faq',
              title: (<>What are investment <WidowBlock>advisory services&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    Through our investment advisory services, we will work with you to develop an investment strategy based on you and your priorities, then recommend and manage those investments to help grow your wealth. Generally speaking, the more complicated your financial situation, the more likely you could benefit from professional guidance.
                  </Typography>
                  <Typography disableBottomPadding>
                    Ready to get started&#63;&nbsp;
                    <Link
                      id='investment-advisory-services-what-are-investment-advisory-services-faq-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Get matched with an advisor
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'investment-advisory-services-who-they-for-faq',
              title: (<>Who are investment advisory <WidowBlock>services for&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    In general, anyone who would rather let a professional construct a well&#45;diversified portfolio and provide ongoing guidance and advice as well as account monitoring. A financial professional will be able to review your account and investments strategy annually &#40;at the very least&#41; to help you stay on track with your goals as they evolve over time.
                  </Typography>
                  <Typography disableBottomPadding>
                    Ready to have us take a look at your investments&#63;&nbsp;
                    <Link
                      id='investment-advisory-services-who-they-for-faq-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'
                      ariaLabel='Get matched with a financial advisor today'>
                      Get matched with an advisor
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'investment-advisory-services-who-can-benefit-faq',
              title: (<>Who can benefit from investment <WidowBlock>advisory services&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    Many people can benefit from expert financial advice&#8212;no matter where they&#39;re starting from. Consider whether you&#39;re the type of investor who wants:
                  </Typography>
                  <BulletedList
                    bulletedListData={[
                      { bulletText: 'Ongoing investment guidance, advice, and ongoing account monitoring' },
                      { bulletText: 'A financial professional to review your account and investments strategy annually (at least) to help you stay on track with your goals as they may evolve over time' },
                      { bulletText: <>A professionally constructed, well&#45;diversified portfolio based on a time&#45;tested investment philosophy and disciplined process</> },
                      { bulletText: 'A financial advisor and firm to use their discretion to manage your portfolio according to your investment goals' },
                      { bulletText: <>An asset&#45;based fee for ongoing advice and account management</> },
                    ]} />
                  <Typography disableBottomPadding>
                    If you think any of these investing characteristics might be a good fit for you, we&#39;re ready to help you reach your goals. Get started by&nbsp;
                    <Link
                      id='investment-advisory-services-who-can-benefit-faq-fafa-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      connecting with an advisor
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'investment-advisory-services-minimum-investment-faq',
              title: (<>What&#39;s the minimum investment for investment <WidowBlock>advisory services&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    It will depend on which of our Advisory Services best fits your needs. Each one is specifically designed for those with more wealth or complex financial situations. Your Northwestern Mutual financial advisor will determine which program is right for your unique situation and amount of assets to be invested.
                  </Typography>
                  <Typography disableBottomPadding>
                    Ready to start investing&#63;&nbsp;
                    <Link
                      id='investment-advisory-services-minimum-investment-faq-fafa-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Get matched with a financial advisor
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'investment-advisory-services-what-is-a-financial-advisor-faq',
              title: (<>What is a <WidowBlock>financial advisor&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    A Northwestern Mutual advisor is your go&#45;to financial professional. They&#39;ll help you make the right decisions so you can live the life you always wanted. They&#39;re specially trained and credentialed to provide&nbsp;
                    <Link
                      id='investment-advisory-services-what-is-a-financial-advisor-faq-advice-link'
                      linkUrl='/financial-advisor/'
                      variant='primaryDeemphasize'>
                      financial planning advice
                    </Link>
                    , investment recommendations, and sell investments and other financial products that will help you reach your goals now, and down the road.
                  </Typography>
                  <Typography disableBottomPadding>
                    Our advisors and planning process puts your interests first, so every recommendation they make will be tailored to you and your needs, not theirs. Sound good&#63;&nbsp;
                    <Link
                      id='investment-advisory-services-what-is-a-financial-advisor-faq-fafa-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'>
                      Get matched with an advisor today
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'investment-advisory-services-what-credentials-faq',
              title: (<>What credentials do your financial <WidowBlock>advisors have&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    Our financial advisors go through training and are properly&nbsp;
                    <Link
                      id='investment-advisory-services-finra-brokercheck-link'
                      variant='primaryDeemphasize'
                      isOutgoingLink
                      linkUrl='https://brokercheck.finra.org/'
                      ariaLabel='Learn about our registered financial advisors through FINRA Brokercheck'>
                      registered and credentialed
                    </Link>
                    . They&#39;ll guide you through the investment process and tailor an investment strategy based on your goals, your level of risk tolerance, and your investment time horizon. They&#39;ll put your financial interests first when recommending products and services and while managing your account. Listening to the priorities of our clients and supporting them is the way we&#39;ve treated them for over 165 years and will continue to do so.
                  </Typography>
                  <Typography disableBottomPadding>
                    Get more details on&nbsp;
                    <Link
                      id='investment-advisory-services-finra-brokercheck-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-and-money/financial-advisor-vs-wealth-manager-whats-the-difference/'
                      ariaLabel='Learn about our registered financial advisors through FINRA Brokercheck'>
                      common financial advisor and wealth manager credentials</Link>. Or if you&#39;re ready to start investing,&nbsp;
                    <Link
                      id='investment-advisory-services-credentials-fafa-link'
                      linkUrl='/find-a-financial-advisor/'
                      variant='primaryDeemphasize'
                      ariaLabel='Get matched with a financial advisor today to learn more about investment advisory services'>
                      get matched with a financial advisor
                    </Link>
                    &nbsp;now.
                  </Typography>
                </>
              ),
            },
            {
              id: 'investment-advisory-what-are-the-risks-investing-with-an-advisor-faq',
              title: (<>Is there any risk to investing with <WidowBlock>an advisor&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    No matter if you work with a financial advisor or manage your investments yourself through a&nbsp;
                    <Link
                      id='investment-advisory-services-brokerage-account-page-link'
                      variant='primaryDeemphasize'
                      linkUrl='/investments/brokerage-accounts-services/'
                      ariaLabel='Learn more about investments, brokerage accounts and services'>
                      brokerage account
                    </Link>
                    , there&#39;s always risk associated with investing in the markets, including potential loss of principal invested. No strategy can assure positive returns or protect against loss, and market fluctuations can impact the performance of your investments. The aim of our advisors is to leverage their knowledge and expertise to help create better financial outcomes through a holistic approach, identifying blind spots, and managing risk through diversification.
                  </Typography>
                  <Typography disableBottomPadding>
                    Get more details on&nbsp;
                    <Link
                      id='investment-advisory-services-investing-risks-article-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-and-money/common-investing-risks-and-how-to-manage-them/'
                      ariaLabel='Read our article on common investing risks and how to manage them'>
                      common investing risks and how to manage them
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'investment-advisory-services-fees-faq',
              title: (<>How are your wealth management advisory <WidowBlock>fees structured&#63;</WidowBlock></>),
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Because of the ongoing advice and account monitoring services your financial advisor provides, you&#39;ll pay a quarterly fee based on the value of the assets in your account. Want to talk with a financial advisor about your goals&#63;&nbsp;
                  <Link
                    id='investment-advisory-services-get-matched-with-a-financial-advisor-link'
                    linkUrl='/find-a-financial-advisor/'
                    variant='primaryDeemphasize'
                    ariaLabel='Get matched with a Financial Advisor'>
                    Get matched
                  </Link>.
                </Typography>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
